// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const UndoIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M5.707 6.707C7.526 4.89 9.774 4 12 4c3.557 0 8 3.156 8 8 0 4.448-3.552 8-8 8-3.478 0-6.15-2.178-7.134-5.3a1 1 0 00-1.908.6C4.185 19.195 7.586 22 12 22c5.552 0 10-4.448 10-10 0-6.156-5.557-10-10-10-2.774 0-5.526 1.111-7.707 3.293L2 7.586V4a1 1 0 00-2 0v6a.997.997 0 00.997 1H7a1 1 0 100-2H3.414l2.293-2.293z"/></svg>'} />;

UndoIcon.displayName = 'UndoIcon';

export default UndoIcon;
